import React from 'react'
import { useTranslation } from "react-i18next";
import Loading from "../../util/Loading";
import { Trans } from "react-i18next";
import {CardWrapper} from "../ui/CardWrapper";
import {InfoCard} from "../ui/InfoCard";
import {Card} from "../ui/Card";
interface IInvoicingTransactionFee{
  onClick:Function;
  loading:boolean;
  state:{
    stage:number,
    url?:string|null
  }
}
export function InvoicingTransactionFee({onClick,loading,state}:IInvoicingTransactionFee) {
  const {t} = useTranslation();
  function renderSteps(){
    if(loading){
      return <Loading/>
    }
    switch (state.stage) {
      case 1: {
        const cardProps = {
            buttonTitle:t("subscription.barclaycard.buttons.ViewBillingDetails"),
            url:state.url,
            disabled: !state.url,
        }
        return <Card {...cardProps}/>  
      }
      default:
        {
          const cardProps = {
              content: <Trans
              i18nKey="subscription.barclaycard.plan.content"
              components={{ div: <div/>}}
              /> ,
              buttonTitle:t("subscription.barclaycard.buttons.SetUpInvoicingPayment"),
              onClick:onClick,
              disabled: false,
          }
          return <Card {...cardProps}/>
        }
    }
  }
  return (
    <>
      <CardWrapper title={t("subscription.cardHeader")}>
        {renderSteps()}
      </CardWrapper>
      <InfoCard
          title={t("subscription.barclaycard.infoCard.title") as string}
          content={<Trans
            i18nKey="subscription.barclaycard.infoCard.content"
            components={{ bold: <strong /> }}
          />}
      />
    </>
  )
}
